import { combineReducers } from "redux";

import countryList from "./countryList";
import fetching from "./fetching";

export default combineReducers({ countryList, fetching });
